




























































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixinV2 from './mixin/mixin-v2.vue';

@Component
export default class Coupon extends mixins(CouponMixinV2) {
  /**
   * 不需要的 props
   * prizeDesc
   * isShowShadow
   * semicircleColor
   * pkgInfo
   * themeLogo
   */
  /** 覆盖 mixin --- 是否展示优惠券底部提示条 */
  // @ts-ignore
  get isShowTips() {
    const result = this.isExpire ? !this.isExpire : !!this.couponInfo.tipsTextRight;
    return result;
  }

  /** 券无障碍展示内容 */
  get couponAiraLabel() {
    const { spDesc, prizeName } = this.couponInfo;
    return this.parseCurrencyAria([spDesc, prizeName].join(' '), true, this.currencyType);
  }
}
